module.exports = __webpack_public_path__ + "e3db2ca7c29e16219850a12aa8df0d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_3.jpg
// module id = 1740
// module chunks = 5